import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../../ui/card';

const TeamSlide = ({ data }) => {
  const avatarColors = [
    'from-cyan-500 to-teal-500',
    'from-teal-500 to-emerald-500',
    'from-emerald-500 to-sky-500',
    'from-sky-500 to-blue-500',
    'from-blue-500 to-indigo-500',
  ];

  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-8"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Team Members */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
        {data.members.map((member, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 + index * 0.1 }}
          >
            <Card className="bg-slate-800/50 border-slate-700/50 p-4 text-center h-full hover:border-cyan-500/30 transition-colors">
              <div className={`w-14 h-14 mx-auto rounded-full bg-gradient-to-br ${avatarColors[index % avatarColors.length]} flex items-center justify-center mb-3`}>
                <span className="text-lg font-bold text-white">{member.avatar}</span>
              </div>
              <h3 className="text-base font-semibold text-white mb-1">{member.name}</h3>
              <p className="text-cyan-400 text-xs mb-2">{member.role}</p>
              <p className="text-slate-400 text-xs leading-tight">{member.credentials}</p>
            </Card>
          </motion.div>
        ))}
      </div>

      {/* AI Team */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
      >
        <Card className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 border-purple-500/20 p-5">
          <h3 className="text-lg font-semibold text-white mb-4 text-center">AI-Powered Operations</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {data.aiTeam.map((role, index) => (
              <div
                key={index}
                className="px-4 py-2 bg-purple-500/10 border border-purple-500/30 rounded-full text-purple-300 text-sm"
              >
                {role}
              </div>
            ))}
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default TeamSlide;
